const Style = ({ theme }) => ({});

export default Style;
